import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  OPEN: "Program Race Card Opened",
  NAVIGATE_TO: COMMON_EVENT_NAMES.NAVIGATED,
  RACE_RERSULTS_VIEWED: "Race Results Viewed"
};
